import React, {useCallback} from 'react';
import I18n from 'app/i18n';
import PrizeCard from 'app/components/reusable/PrizeCard';
import {amountWithSign, timeStampToTimeShortFormat} from 'app/utils';
import {artifactName} from 'app/components/my_profile/artifacts/utils';
import LotArtifactInterface from 'app/interfaces/LotArtifactInterface';
import LotOrderInterface from 'app/interfaces/LotOrderInterface';

interface LotItemProps extends LotOrderInterface {
    cancelOrder: (artifact: LotArtifactInterface, id: number) => void
}

const LotItem = ({artifact, cancelOrder, created_at, id, total_price}: LotItemProps): React.ReactElement => {
    const handleCancelOrder = useCallback(() => {
        cancelOrder(artifact, id);
    }, [
        artifact,
        cancelOrder,
        id
    ]);

    return <div className="market__lots__item">
        <div className="market__lots__item__name-placed">
            <div className="market__lots__item--img-wrap">
                <div className="market__lots__item--img market-item-card">
                    <PrizeCard artifact={artifact} hideMeta hideName/>
                </div>
            </div>
            <div className="market__lots__item--desc-placed">
                <div className="market__lots__item--desc">
                    <div className="market__lots__item--desc-title">{artifactName(artifact)}</div>
                </div>
                <div className="market__lots__item__placed">{timeStampToTimeShortFormat(created_at)}</div>
            </div>
        </div>
        <div className="market__lots__item__price-actions">
            <div className="market__lots__item__price-value">{amountWithSign(Number(total_price))}</div>
            <div className="market__lots__item__actions">
                <button
                    className="btn--invert"
                    onClick={handleCancelOrder}
                >{I18n.t('user.delete')}</button>
            </div>
        </div>
    </div>;
};

export default LotItem;
